import { combineReducers } from 'redux';

import data from './data';
import importSlice from './ui/import';

const ui = combineReducers({
  import: importSlice,
});

const reducer = combineReducers({
  data,
  ui,
});

export type TireScansReducer = ReturnType<typeof reducer>;

export default reducer;
